import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CertificationsModel } from 'src/app/models/certifications.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-certification-modal',
    imports: [FormsModule, MatButtonModule, MatIconModule],
    templateUrl: './certification-modal.component.html',
    styleUrls: ['./certification-modal.component.scss']
})
export class CertificationModalComponent {
  toastr = inject(ToastService);
  supplierSvc = inject(SupplierService);

  newCertificate!: CertificationsModel;

  name: string = '';
  description: string = '';
  duration: number | null = null;
  issuingAuthority: string = '';
  isActive: boolean = true;
  dialogRef = inject(MatDialogRef<CertificationModalComponent>)
  data = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    if (this.data) {
      this.name = this.data.name;
      this.description = this.data.description;
      this.duration = this.data.duration;
      this.issuingAuthority = this.data.issuingAuthority;
    }
  }

  onSubmit() {
    if (this.validateForm()) {
      if (!this.data) {
        this.supplierSvc.postCertification(this.newCertificate).subscribe({
          next: (result) => {
            this.toastr.success(
              'Certificación registrada',
              'La certificación ' +
                this.newCertificate.name +
                ' se ha registrado correctamente.'
            );
            this.clearForm();
          },
          error: (err) => {
            this.toastr.error(
              'Error',
              'No se pudo registrar la certificación. Todos los campos son obligatorios' +
                err.error.error
            );
          },
        });
      } else {
        if (this.duration != null) {
          this.data = {
            id: this.data.id,
            name: this.name,
            duration: this.duration,
            issuingAuthority: this.issuingAuthority,
            description: this.description,
            nameWithAuthority: '',
            isActive: this.isActive,
          };
          this.supplierSvc
            .patchCertification(this.data.id, this.data)
            .subscribe({
              next: (result) => {
                this.toastr.success(
                  'Certificación editada',
                  'La certificación ' +
                    this.newCertificate.name +
                    ' se ha editado correctamente.'
                );
                this.clearForm();
              },
              error: (err) => {
                this.toastr.error(
                  'Error',
                  'No se pudo editar la certificación.' + err.error
                );
              },
            });
        }
      }
    }
  }

  validateForm() {
    if (
      this.name != '' &&
      this.description != '' &&
      this.issuingAuthority != '' &&
      this.duration != null &&
      this.duration != 0 &&
      this.duration <= 99999
    ) {
      this.newCertificate = {
        id: '',
        name: this.name,
        duration: this.duration,
        issuingAuthority: this.issuingAuthority,
        description: this.description,
        nameWithAuthority: '',
        isActive: this.isActive,
      };
      return true;
    } else {
      this.toastr.error(
        'Error',
        'No se pudo registrar la certificación. Todos los campos son obligatorios y la duración debe ser menor a 100000 horas.'
      );
      return false;
    }
  }

  clearForm() {
    this.name = '';
    this.description = '';
    this.duration = 0;
    this.issuingAuthority = '';
    this.cancelClick();
  }

  cancelClick() {
    this.dialogRef.close();
  }

  validateOnlyNumbers(event: KeyboardEvent) {
    let key = event.key;
    if (['.', 'e', 'E', ',', '-', '+'].includes(key)) {
      event.preventDefault();
    }
  }

  validateSpecialCharacters(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    input.value = value.replaceAll(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
  }

  validateDuration(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length > 5) {
      input.value = value.slice(0, 5);
    }
  }
}
